import React from 'react';
import { ModelPreloader } from 'client/data/luckdragon/redux/model-preloader';
import { pageDefinition } from 'site-modules/shared/pages/page';
import { getModelState } from 'client/data/luckdragon/model';
import { parseContent } from 'client/data/cms/content';
import { getMeta, getMetaRobots } from 'site-modules/shared/utils/seo-helper';
import { getMediaKitArticleContentPath } from 'site-modules/editorial/utils/content-path';
import { CmsModel } from 'client/data/models/cms';
import { handle404Error } from 'site-modules/shared/utils/errors';
import { MediaKitArticle } from './media-kit';

export const getPageOptions = ({ splat, type, articleId }) => ({
  name: 'other',
  category: 'other',
  preload: store => {
    const preloader = new ModelPreloader(store);

    const articlePath = getMediaKitArticleContentPath(splat, type, articleId);
    preloader.resolve(`content["${articlePath}"]`, CmsModel);

    return preloader.load().then(modelState => {
      const article = modelState.get(`content["${articlePath}"]`, CmsModel);

      if (!(article && article.id)) {
        throw handle404Error({ errorMessage: `No content was found for ${articlePath}` });
      }

      return preloader.load();
    });
  },
  seo: store => {
    const modelState = getModelState(store);
    const articlePath = getMediaKitArticleContentPath(splat, type, articleId);
    const content = parseContent(modelState.get(`content["${articlePath}"]`, CmsModel));
    const robots = getMetaRobots(content);

    return {
      ...getMeta(content),
      ...robots,
    };
  },
  component: () => <MediaKitArticle splat={splat} type={type} articleId={articleId} />,
});

export default ({ splat: splatParam = '', articleId }) => {
  const [splat, type] = splatParam.split('/');

  return pageDefinition(getPageOptions({ splat, type, articleId }));
};
